import { getServiceContainer } from '../service-container';
export const OPERATOR_ROLE = 'user-management/operator-role()';
export class AccessControl {
    constructor() {
        this.roles = {};
        this.permissions = {};
        this.effectiveRoles = {};
        this.effectivePermissions = {};
        this.state = getServiceContainer().resolve('IState');
        this.parsePermissions();
        window.addEventListener('authenticationStateReceived', () => {
            this.parsePermissions();
        });
    }
    onUpdate(callback) {
        console.debug('on access update', callback);
        callback(); // setup the component access on its startup
        return window.addEventListener('edlAccessUpdated', callback);
    }
    clearUpdate(callback) {
        console.debug('clear access update', callback);
        return window.removeEventListener('edlAccessUpdated', callback);
    }
    notify() {
        console.debug('notifying access change');
        window.dispatchEvent(new CustomEvent('edlAccessUpdated'));
    }
    impersonate(roles, permissions) {
        this.effectiveRoles = Object.assign({}, roles);
        this.effectivePermissions = Object.assign({}, permissions);
        this.notify();
    }
    parsePermissions() {
        var _a, _b, _c;
        if (!((_c = (_b = (_a = this.state.authentication) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.roles) === null || _c === void 0 ? void 0 : _c.length)) {
            console.debug('backend has not sent the user roles');
            return;
        }
        this.roles = {};
        this.permissions = {};
        this.state.authentication.user.roles.forEach((r) => {
            this.roles[`${r.id}(${r.target})`] = r;
            r.permissions.forEach((p) => {
                this.permissions[`${p.id}(${p.target})`] = p;
            });
        });
        console.debug('user roles:', this.roles);
        console.debug('user permissions:', this.permissions);
        this.stopImpersonation();
    }
    stopImpersonation() {
        this.effectiveRoles = Object.assign({}, this.roles);
        this.effectivePermissions = Object.assign({}, this.permissions);
        this.notify();
    }
    imp() {
        // TODO: get actual permissions of a regular user
        this.impersonate([], []);
    }
    /**
     * Tell if the real user identity has the operator role
     * Should only be used in the Operator Menu.
     * @return true if operator
     */
    isReallyOperator() {
        return this.roles[OPERATOR_ROLE] != undefined;
    }
    /**
     * Check if the user effectively has the specified role
     * @param role - the required role (by default 'operator-role')
     * @return true if operator
     */
    hasRole(role = OPERATOR_ROLE) {
        return this.effectiveRoles[role] != undefined;
    }
    /**
     * Check if the user effectively has the required permission
     * @param permission - the required permission
     * @return true if the user has the required permission
     */
    allows(permission) {
        return this.effectivePermissions[permission] != undefined;
    }
}
